import { ArrowLeft, ChevronLeft, ChevronRight } from "lucide-react";
import React from "react";

const Pagination = ({
  page = 1,
  totalPages = 1,
  limit = 10,
  totalItems = 0,
  onPageChange = () => {},
  onLimitChange = () => {},
  loading = false,
}) => {
  const pageNumbers = [];
  const maxPagesToShow = 5;

  // Calculate start and end page
  let startPage = Math.max(1, page - Math.floor(maxPagesToShow / 2));
  let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

  if (endPage - startPage + 1 < maxPagesToShow) {
    startPage = Math.max(1, endPage - maxPagesToShow + 1);
  }

  for (let p = startPage; p <= endPage; p++) {
    pageNumbers.push(p);
  }

  if (!totalItems === 0) {
    return <p className="text-center p-2 text-sm">No records found</p>;
  }

  return (
    <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
      {/* Limit selector */}
      <div className="d-flex align-items-center gap-2">
        <select
          className="form-select form-select-sm rounded-pill py-1 px-3 border-dark  equal-height"
          style={{ minWidth: "130px" }}
          value={limit}
          onChange={(e) => {
            onLimitChange(Number(e.target.value));
            onPageChange(1);
          }}
          disabled={loading}
        >
          {[10, 20, 50, 100, 500].map((size) => (
            <option key={size} value={size}>
              Show {size}
            </option>
          ))}
        </select>
      </div>

      {/* Page buttons */}
      <div className="d-flex gap-2 flex-wrap align-items-center">
        <button
          className="btn d-flex align-items-center gap-1 border border-dark rounded-pill px-3  equal-height"
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1 || loading}
          style={{ background: "#f8f9fa" }}
        >
          <ChevronLeft size={18} />
        </button>

        <small className="mb-0">
          {page} of {totalPages || 1}
        </small>

        <button
          className="btn btn-sm d-flex align-items-center gap-1 border border-dark rounded-pill px-3  equal-height"
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages || totalPages === 0 || loading}
          style={{ background: "#f8f9fa" }}
        >
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
